// Builder desk numbers from /dev/projects + each project's /timeline (pure; tested).
export const KIND_LABEL = {
  orthomosaic: "Map", model_3d: "3D model", point_cloud: "Point cloud", site_scan: "Site scan",
  elevation: "Elevation", stills: "Aerial stills", video: "Flyover video", report: "Report", other: "File",
};
const UPCOMING = new Set(["pending", "scheduled"]);

export function summarize(projects, timelines, today) {
  const rows = (projects || []).map((p) => {
    const t = timelines[p.id] || null;
    const visits = (t && t.visits) || [];
    const delivered = visits.filter((v) => (v.deliverables || []).length);
    const last = delivered.reduce((m, v) => (v.date && (!m || v.date > m) ? v.date : m), null);
    const kinds = t && t.summary && t.summary.kinds ? Object.keys(t.summary.kinds) : [];
    return { id: p.id, name: p.name, place: [p.address, p.city].filter(Boolean).join(", "), status: p.status,
      monitoring: p.subscription_status === "active", visits: visits.length, delivered: delivered.length,
      last, kinds, loaded: !!t };
  });
  const upcoming = [];
  const latest = [];
  (projects || []).forEach((p) => {
    ((timelines[p.id] && timelines[p.id].visits) || []).forEach((v) => {
      if (UPCOMING.has(v.status) && (!v.date || v.date >= today)) upcoming.push({ ...v, project: p.name });
      if ((v.deliverables || []).length) latest.push({ ...v, project: p.name });
    });
  });
  upcoming.sort((a, b) => (a.date || "9999").localeCompare(b.date || "9999"));
  latest.sort((a, b) => (b.date || "").localeCompare(a.date || ""));
  return {
    rows,
    upcoming: upcoming.slice(0, 5),
    latest: latest.slice(0, 5),
    kpis: {
      projects: rows.length,
      monitoring: rows.filter((r) => r.monitoring).length,
      visits: rows.reduce((n, r) => n + r.visits, 0),
      delivered: rows.reduce((n, r) => n + r.delivered, 0),
      next: upcoming.find((v) => v.date) || null,
    },
  };
}
